import { render, staticRenderFns } from "./historyList.vue?vue&type=template&id=63822ed2&scoped=true"
import script from "./historyList.vue?vue&type=script&lang=js"
export * from "./historyList.vue?vue&type=script&lang=js"
import style0 from "./historyList.vue?vue&type=style&index=0&id=63822ed2&prod&lang=scss&scoped=true"
import style1 from "./historyList.vue?vue&type=style&index=1&id=63822ed2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63822ed2",
  null
  
)

export default component.exports